import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
// 页面默认配置，非必须，在从接口没获取到的时候，使用默认配置
import { PAGE_CONFIG_MAP } from './config';
import { useParams } from 'umi';

// 配置页面默认承接页
export default  () => {
  // 获取module和report，组装path，路由规则：/:module/:report/:tab?
  const { module = '', report = '' } = useParams() || {} as any;
  const realPath = `/${module}/${report}`;
  return (
    <>
      <CommonPageRender reqParams={realPath} pageConfigInit={PAGE_CONFIG_MAP?.[realPath]} key={realPath}/>
    </>
  );
};
